import { useSyncExternalStore } from 'react';
import type { Id } from '@contracts/common';
import type { WorkplaceFilters, WorkplaceView } from './model';

/**
 * Plan P3 D161, D173: what the Workplace page shows, for Hana's page context — the view on screen, the effective
 * filters, the card picked or open, the tree the rail narrowed to, and whether a search is active (never its text).
 * The top-level Workplace publishes it and clears it on leaving; a project's embedded board does not (that page's
 * context is the project).
 */
export type WorkplaceFocus = { view: WorkplaceView; filters: WorkplaceFilters; selectedId: Id | null;
  selectedType: 'task' | 'note' | null; tree: Id | null; searching: boolean };

let current: WorkplaceFocus | null = null;
const listeners = new Set<() => void>();

export function publishWorkplaceFocus(next: WorkplaceFocus | null): void {
  current = next;
  for (const listener of listeners) listener();
}
export function readWorkplaceFocus(): WorkplaceFocus | null {
  return current;
}
function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
export function useWorkplaceFocus(): WorkplaceFocus | null {
  return useSyncExternalStore(subscribe, readWorkplaceFocus, readWorkplaceFocus);
}
